module.exports = __webpack_public_path__ + "static/bruce-mars-FWVMhUa_wbY-unsplash-fit-0f1bcb000e8ef4b684c8f9823d5de246.jpg";